import { call, put, takeLatest } from "redux-saga/effects";
import {
  onPostVendorOrder,
  onPostVendorOrderError,
  onPostVendorOrderSuccess,
} from "../Store/Slices/vendorOrderSlice";
import { callVendorOrderPostApi } from "../Context/vendorOrderApi";
import { decryptAES } from "../Common/Axios/encrypt";

function* PostVendorOrder({ payload }) {
  try {
    const postVendorOrderResponse = yield call(callVendorOrderPostApi, payload);
    if (postVendorOrderResponse.httpStatusCode === "201") {
      yield put(
        onPostVendorOrderSuccess({
          postData: postVendorOrderResponse.response,
          message: postVendorOrderResponse.errorMessage,
          status_code: postVendorOrderResponse.httpStatusCode,
        }),
      );
    } else {
      yield put(
        onPostVendorOrderError({
          postData: postVendorOrderResponse.response,
          message: postVendorOrderResponse.errorMessage,
          status_code: postVendorOrderResponse.httpStatusCode,
        }),
      );
    }
  } catch (error) {
    const message =
      decryptAES(error?.response?.data)?.errorMessage || "Something went wrong";
    yield put(onPostVendorOrderError({ postData: decryptAES(error?.response?.data)?.response?.stockOutDenominations, message, status_code: 400 }));
  }
}
export default function* vendorOrderSaga() {
  yield takeLatest(onPostVendorOrder.type, PostVendorOrder);
}
